import { FC, Fragment, useCallback, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { EditOutlined } from '@mui/icons-material';

import { Campaign } from '../../../../../types/Campaign';
import ApiService from '../../../../../ApiService';
import AssignDspCampaignDialog from '../Dialog/AssignDspCampaignDialog';

interface AssignDspCampaignButtonProps {
    campaign: Campaign;
    onChange?: (campaign: Campaign) => void;
}

const AssignDspCampaignButton: FC<AssignDspCampaignButtonProps> = ({ campaign, onChange = undefined }) => {
    const [open, setOpen] = useState<boolean>(false);

    const handleOnClose = useCallback(
        (dspCampaignId: string | null) => {
            setOpen(false);
            if (dspCampaignId !== null) {
                const updateCampaign = { ...campaign, dspCampaignId: dspCampaignId };

                ApiService.updateCampaign(updateCampaign).then((response) => {
                    if (onChange) {
                        onChange(response.data);
                    }
                });
            }
        },
        [setOpen, onChange]
    );

    return (
        <Fragment>
            <Tooltip title={'Assign DSP Campaign ID'}>
                <IconButton disableRipple sx={{ fontSize: 16, py: 0 }} onClick={() => setOpen(true)}>
                    <EditOutlined fontSize="small" />
                </IconButton>
            </Tooltip>

            {open && <AssignDspCampaignDialog campaign={campaign} onClose={handleOnClose} />}
        </Fragment>
    );
};

export default AssignDspCampaignButton;
